// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltipContainer:hover > div > *,
.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltipContainer:focus-within > .app-components-Table-Cells-ColumnTimeline-___Tooltips-module__item > div > div > *,
.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltipContainer:hover > .app-components-Table-Cells-ColumnTimeline-___Tooltips-module__item > div > div > *,
.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltipContainer:focus-within > div > *,
.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__item:hover > div > div > *,
.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__item:focus-within > div > div > * {
  visibility: visible;
  opacity: 1;
}

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip {
  visibility: hidden;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 6px;
  padding: 0px 5px;
  position: absolute;
  z-index: 100;
  left: 50%;
  margin-left: -60px;
  font-size: 12px;
  z-index: 10;
  white-space: pre-line;
  opacity: 0;
  transition: opacity 0.3s;
  margin-bottom: 10px;
  bottom: 100%;
}

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='top'] {
    margin-bottom: 10px;
    bottom: 100%;
  }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='top']::after {
      content: ' ';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.7) transparent transparent transparent;
    }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='bottom'] {
    margin-top: 10px;
    top: 100%;
    bottom: unset;
  }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='bottom']::after {
      content: ' ';
      position: absolute;
      bottom: 100%; /* At the top of the tooltip */
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent rgba(0, 0, 0, 0.7) transparent;
    }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='right'] {
    margin-left: 20px;
    width: auto;
    white-space: nowrap;
    left: 100%;
    bottom: unset;
    height: 20px;
    top: calc(50% - 10px);
    z-index: 10;
    display: flex;
    align-items: center;
  }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip[position='right']::after {
      content: ' ';
      position: absolute;
      right: 100%; /* At the top of the tooltip */
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent rgba(0, 0, 0, 0.7) transparent transparent;
    }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__fixFirstRow {
    bottom: 0;
  }

.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip.app-components-Table-Cells-ColumnTimeline-___Tooltips-module__fixLastRow {
    top: 0;
  }
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/ColumnTimeline/Tooltips.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAME,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AAgEd;;AA9DE;IACE,mBAAmB;IACnB,YAAY;EAYd;;AAVE;MACE,YAAY;MACZ,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,iBAAiB;MACjB,iBAAiB;MACjB,mBAAmB;MACnB,oEAAoE;IACtE;;AAEF;IACE,gBAAgB;IAChB,SAAS;IACT,aAAa;EAYf;;AAVE;MACE,YAAY;MACZ,kBAAkB;MAClB,YAAY,EAAE,8BAA8B;MAC5C,SAAS;MACT,iBAAiB;MACjB,iBAAiB;MACjB,mBAAmB;MACnB,oEAAoE;IACtE;;AAGF;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,mBAAmB;EAWrB;;AATE;MACE,YAAY;MACZ,kBAAkB;MAClB,WAAW,EAAE,8BAA8B;MAC3C,iBAAiB;MACjB,iBAAiB;MACjB,mBAAmB;MACnB,oEAAoE;IACtE;;AAGF;IACE,SAAS;EACX;;AAEA;IACE,MAAM;EACR","sourcesContent":[".tooltipContainer:hover > div > *,\n.tooltipContainer:focus-within > .item > div > div > *,\n.tooltipContainer:hover > .item > div > div > *,\n.tooltipContainer:focus-within > div > *,\n.item:hover > div > div > *,\n.item:focus-within > div > div > * {\n  visibility: visible;\n  opacity: 1;\n}\n\n.tooltip {\n  visibility: hidden;\n  width: 120px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  border-radius: 6px;\n  padding: 0px 5px;\n  position: absolute;\n  z-index: 100;\n  left: 50%;\n  margin-left: -60px;\n  font-size: 12px;\n  z-index: 10;\n  white-space: pre-line;\n  opacity: 0;\n  transition: opacity 0.3s;\n  margin-bottom: 10px;\n  bottom: 100%;\n\n  &[position='top'] {\n    margin-bottom: 10px;\n    bottom: 100%;\n\n    &::after {\n      content: ' ';\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.7) transparent transparent transparent;\n    }\n  }\n  &[position='bottom'] {\n    margin-top: 10px;\n    top: 100%;\n    bottom: unset;\n\n    &::after {\n      content: ' ';\n      position: absolute;\n      bottom: 100%; /* At the top of the tooltip */\n      left: 50%;\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent rgba(0, 0, 0, 0.7) transparent;\n    }\n  }\n\n  &[position='right'] {\n    margin-left: 20px;\n    width: auto;\n    white-space: nowrap;\n    left: 100%;\n    bottom: unset;\n    height: 20px;\n    top: calc(50% - 10px);\n    z-index: 10;\n    display: flex;\n    align-items: center;\n\n    &::after {\n      content: ' ';\n      position: absolute;\n      right: 100%; /* At the top of the tooltip */\n      margin-left: -5px;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent rgba(0, 0, 0, 0.7) transparent transparent;\n    }\n  }\n\n  &.fixFirstRow {\n    bottom: 0;\n  }\n\n  &.fixLastRow {\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltipContainer`,
	"item": `app-components-Table-Cells-ColumnTimeline-___Tooltips-module__item`,
	"tooltip": `app-components-Table-Cells-ColumnTimeline-___Tooltips-module__tooltip`,
	"fixFirstRow": `app-components-Table-Cells-ColumnTimeline-___Tooltips-module__fixFirstRow`,
	"fixLastRow": `app-components-Table-Cells-ColumnTimeline-___Tooltips-module__fixLastRow`
};
export default ___CSS_LOADER_EXPORT___;
